import React from 'react';

import GenericField from './shared/GenericField';
import DateInputContainer from './date/DateInputContainer';

/**
 * Date field input.
 * @param {string} [label] Label description for field input.
 * @param {string} [initialValue] Field value, 'YYYY-MM-DD', '' or null.
 * @param {function} [handleSave] [async string=>{bool success, string message}] Save changes / return error message.
 */
const Date = ({ label, initialValue, handleSave: syncChanges }) => {
    return (
        <GenericField>
            {label}
            <DateInputContainer {...{ initialValue, syncChanges }} />
        </GenericField>
    );
};

export default Date;
